import * as React from 'react';

import { SuggestReminderPublishersReminderPublisherCollection200ResponseSuggestionsInner } from '@europrocurement/l2d-domain/openApi/ApiAchats';
import { arrowLeftIcon, FaOptionIcon, reminderPublisherIcon } from '@europrocurement/l2d-icons';
import { Box, Button } from '@mui/material';
import { EmptyBox } from '@europrocurement/flexy-components';
import FormModal from '../../../../../../Achats/components/modals/FormModal/FormModal';
import { ChoiceProps } from '../../../../../../Achats/components/modals/FormModal/types';
import { AVAILABLE_SOCIETIES } from '../../constants/societyData';

type SupplierSuggestion =
    SuggestReminderPublishersReminderPublisherCollection200ResponseSuggestionsInner;

type SuggestionSelectorProps = {
    suggestions: SupplierSuggestion[];
    isMultiSocietyMode: boolean;
    isProcessing: boolean;
    onSelectionChange: (suggestion: SupplierSuggestion, checked: boolean) => void;
    onBack: () => void;
    onContinue: () => void;
};

const SuggestionSelector: React.FunctionComponent<SuggestionSelectorProps> = function ({
    suggestions,
    isMultiSocietyMode,
    isProcessing,
    onSelectionChange,
    onBack,
    onContinue,
}: SuggestionSelectorProps) {
    console.log('Rendering SuggestionSelector with suggestions:', suggestions);

    const choices = React.useMemo(
        (): ChoiceProps[] =>
            suggestions.map((suggestion, index) => {
                // Récupérer le nom de la société pour l'affichage
                let societyLabel = '';
                if (suggestion.idSociete) {
                    const society = AVAILABLE_SOCIETIES.find((s) => s.id === suggestion.idSociete);
                    societyLabel = society ? ` - ${society.label}` : '';
                }

                const uniqueKey = `${suggestion.fournisseur.id}_${suggestion.idSociete || 'default'}`;

                return {
                    label: `${suggestion.fournisseur.nom} (${suggestion.factures.length} facture${
                        suggestion.factures.length > 1 ? 's' : ''
                    })${societyLabel}`,
                    value: uniqueKey,
                    action: (_, checked) => {
                        console.log('Selection changed:', suggestion.fournisseur.nom, checked);
                        onSelectionChange(suggestion, checked);
                    },
                    defaultSelected: index === 0,
                };
            }),
        [onSelectionChange, suggestions],
    );

    if (!suggestions || suggestions.length === 0) {
        return (
            <Box sx={{ p: 3, width: '500px', maxWidth: '90vw' }}>
                <EmptyBox text="Aucun fournisseur avec factures disponibles" />
                <Box
                    display="flex"
                    justifyContent="center"
                    mt={3}
                >
                    <Button
                        variant="outlined"
                        onClick={onBack}
                        startIcon={<FaOptionIcon {...arrowLeftIcon.props} />}
                    >
                        Retour au choix de société
                    </Button>
                </Box>
            </Box>
        );
    }

    return (
        <FormModal
            inputNature="select"
            title="Sélection des fournisseurs"
            context="Sélectionnez un ou plusieurs fournisseurs pour créer des rappels."
            choices={choices}
            icon={reminderPublisherIcon}
            uniqChoice={!isMultiSocietyMode}
            submitActions={[
                {
                    type: 'cancel',
                    action: () => {
                        console.log('Back button clicked');
                        onBack();
                    },
                    label: 'Retour au choix de société',
                    disabled: isProcessing,
                },
                {
                    type: 'confirm',
                    action: onContinue,
                    label: 'Continuer',
                    disabled: isProcessing,
                },
            ]}
        />
    );
};

export default SuggestionSelector;
